module.exports = __webpack_public_path__ + "img/side-entrance.6b9ae9a9.jpg";